import { Card, Text, Box, Title } from '@nimbus-ds/components';
import { Trans, useTranslation } from 'react-i18next';
import { OrderDetailsResponseDto } from '@tiendanube/common';
import { Domain as DomainEnum } from '@tiendanube/common/src/enums';
import LocationText from 'domains/Orders/components/LocationText';

interface CardPickupProps {
  order: OrderDetailsResponseDto;
}

function CardPickupAddress({
  order: {
    fulfillment: { pickupDetail },
    ocaStoreCode,
  },
}: Readonly<CardPickupProps>) {
  const { t } = useTranslation([DomainEnum.ORDERS]);

  const title = t('cardPickupAddress.title');
  if (!pickupDetail?.locationName) return null;
  const {
    firstName,
    lastName,
    locationName,
    locationAdress,
    locationCity,
    locationProvince,
    locationCountry,
    locationZipcode,
    locationBetweenStreet,
    locationReference,
  } = pickupDetail;

  return (
    <Card title={title}>
      <Card.Header>
        <Box alignItems="center" display="flex" justifyContent="space-between">
          <Title as="h4">{title}</Title>
        </Box>
      </Card.Header>
      <Card.Body>
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          gap="2"
        >
          <Box>
            <Text color="neutral-textHigh">{locationName}</Text>
            {!!ocaStoreCode && (
              <Text>
                <Trans
                  t={t}
                  i18nKey="cardDeliveryAddress.ocaStoreCode"
                  values={{
                    code: ocaStoreCode,
                  }}
                  components={{
                    strong: <strong />,
                  }}
                />
              </Text>
            )}
            <LocationText
              street={locationAdress}
              city={locationCity}
              province={locationProvince}
              country={locationCountry}
              zipcode={locationZipcode}
              betweenStreet={locationBetweenStreet}
              reference={locationReference}
            />
          </Box>
          <Box>
            <Text
              fontSize="base"
              lineHeight="base"
              color="neutral-textHigh"
              textAlign="left"
            >
              <Text>
                {`${t(
                  'cardPickupAddress.pickupName',
                )} ${firstName} ${lastName}`}
              </Text>
            </Text>
          </Box>
        </Box>
      </Card.Body>
    </Card>
  );
}

export default CardPickupAddress;
